import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { ClientePipeSharedModule } from '../../pipes';
import { ClienteAnaliseFinanceiraFormModule } from '../form';

import { ClienteAnaliseFinanceiraRevisarModalComponent } from './cliente-analise-financeira-revisar-modal.component';

@NgModule({
    imports: [
        SharedModule,
        ClientePipeSharedModule,
        ClienteAnaliseFinanceiraFormModule
    ],
    declarations: [
        ClienteAnaliseFinanceiraRevisarModalComponent
    ],
    exports: [
        ClienteAnaliseFinanceiraRevisarModalComponent
    ]
})
export class ClienteAnaliseFinanceiraRevisarModule { }
